import { type FC } from 'react'

import {
  FreeformTextareaEditor,
  type FreeformTextareaProps
} from '../FreeformTextareaEditor/FreeformTextareaEditor'

export const PythonEditor: FC<FreeformTextareaProps> = ({ ...props }) => (
  <FreeformTextareaEditor {...props} language={'python'} />
)
